import { render, staticRenderFns } from "./ElementScaleNameTableColumn.vue?vue&type=template&id=45b982e4&scoped=true"
import script from "./ElementScaleNameTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleNameTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b982e4",
  null
  
)

export default component.exports